import { render, staticRenderFns } from "./invitations.modal.vue?vue&type=template&id=2bde74e6&scoped=true"
import script from "./invitations.modal.vue?vue&type=script&lang=js"
export * from "./invitations.modal.vue?vue&type=script&lang=js"
import style0 from "./invitations.modal.vue?vue&type=style&index=0&id=2bde74e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde74e6",
  null
  
)

export default component.exports